import { render, staticRenderFns } from "./RSNavigationPanel.vue?vue&type=template&id=179afa8c&"
import script from "./RSNavigationPanel.vue?vue&type=script&lang=js&"
export * from "./RSNavigationPanel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1477836768/src/github.com/FebosIO/Febos-AMI/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('179afa8c')) {
      api.createRecord('179afa8c', component.options)
    } else {
      api.reload('179afa8c', component.options)
    }
    module.hot.accept("./RSNavigationPanel.vue?vue&type=template&id=179afa8c&", function () {
      api.rerender('179afa8c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/febos/global/customDocuments/components/repository-selector/RSNavigationPanel.vue"
export default component.exports